import { GetImages } from "../../utils/GetImages";
import { useMenu } from "../../utils/context/MenuContext";
import selectedDashboardIcon from "../../assets/selectedDashboard.svg";
import arrowBackIcon from "../../assets/arrow_back.svg";
import MenuItemCustom from "../../layout/MenuItemCustom";
import { useNavigate, useLocation } from "react-router";
import { PermissionGuard } from "../../newComponents/PermissionGuard";
import BluePayableIcon from "../../assets/Payment-Icon.svg";

const OrganizationSidebar = ({ pageType = "organization" }) => {
  const { isOpen, isHidden, setIsOpen, setIsHidden } = useMenu();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedTab = location.pathname;

  return (
    <div
      className={`organizationSidebarContainer d-flex flex-column gap-2 ${
        isHidden ? "hiddenMenu" : isOpen ? "opened" : "closed"
      }`}
    >
      <div
        className="sidebarToggleCenter organizationBackground"
        onClick={() => {
          const size = window.innerWidth;
          if (size < 400) {
            setIsHidden(true);
            setIsOpen(!isOpen);
          } else {
            setIsOpen(!isOpen);
          }
        }}
      >
        <img
          src={
            isOpen ? GetImages.BlackChevronLeft : GetImages.BlackChevronRight
          }
          alt="toggle"
        />
      </div>

      <div
        className={isOpen ? "normalClass" : "collapsedBarClass"}
        data-title={!isOpen ? "Dashboard" : ""}
      >
        <MenuItemCustom
          primaryText="Dashboard"
          to="/"
          key={"newMenu-1"}
          className={
            location.pathname === "/"
              ? "menuItemLinkClassSelected dashtext-text"
              : "menuItemLinkClass"
          }
          leftIcon={
            location.pathname === "/" ? selectedDashboardIcon : arrowBackIcon
          }
          isSelected={location.pathname === "/"}
          alt="Dashboard Icon"
        />
      </div>

      {pageType === "organization" ? (
        <>
          <PermissionGuard permission="OrganizationDashboard">
            <div
              className={`${
                selectedTab === "/organization/new-overview"
                  ? "organizationSidebarTabSelected clickable"
                  : "organizationSidebarTab clickable"
              } ${!isOpen ? "collapsedBarClass" : ""}`}
              data-title={!isOpen ? "OVERVIEW" : ""}
              onClick={() => {
                navigate("new-overview");
              }}
            >
              <img height={26} width={26} src={GetImages.overviewOrgIcon} />
              <p>OVERVIEW</p>
            </div>
          </PermissionGuard>

          <PermissionGuard permission="PaymentAccounts">
            <div
              onClick={() => {
                navigate("new-payment-accounts");
              }}
              className={`${
                selectedTab === "/organization/new-payment-accounts"
                  ? "organizationSidebarTabSelected clickable"
                  : "organizationSidebarTab clickable"
              } ${!isOpen ? "collapsedBarClass" : ""}`}
              data-title={!isOpen ? "Payment Accounts" : ""}
            >
              <img
                height={26}
                width={26}
                src={BluePayableIcon}
                style={{ filter: "brightness(0) invert(1)" }}
              />
              <p>Payment Accounts</p>
            </div>
          </PermissionGuard>

          <PermissionGuard permission="PayeeAccounts">
            <div
              onClick={() => {
                navigate("new-payee-accounts");
              }}
              className={`${
                selectedTab === "/organization/new-payee-accounts"
                  ? "organizationSidebarTabSelected clickable"
                  : "organizationSidebarTab clickable"
              } ${!isOpen ? "collapsedBarClass" : ""}`}
              data-title={!isOpen ? "Payee Accounts" : ""}
            >
              <img height={26} width={26} src={GetImages.payeeAccOrgIcon} />
              <p>Payee Accounts</p>
            </div>
          </PermissionGuard>

          <PermissionGuard permission="ManageUsers">
            <div
              onClick={() => {
                navigate("new-manage-users");
              }}
              className={`${
                selectedTab === "/organization/new-manage-users"
                  ? "organizationSidebarTabSelected clickable"
                  : "organizationSidebarTab clickable"
              } ${!isOpen ? "collapsedBarClass" : ""}`}
              data-title={!isOpen ? "Manage users" : ""}
            >
              <img height={26} width={26} src={GetImages.manageUserOrgIcon} />
              <p>Manage users</p>
            </div>
          </PermissionGuard>

          <PermissionGuard permission="Reports">
            <div
              onClick={() => {
                navigate("reports");
              }}
              className={`${
                selectedTab === "/organization/reports"
                  ? "organizationSidebarTabSelected clickable"
                  : "organizationSidebarTab clickable"
              } ${!isOpen ? "collapsedBarClass" : ""}`}
              data-title={!isOpen ? "Reports" : ""}
            >
              <img height={26} width={26} src={GetImages.reportsOrgIcon} />
              <p>Reports</p>
            </div>
          </PermissionGuard>

          <PermissionGuard permission="Templates">
            <div
              onClick={() => {
                navigate("templates");
              }}
              className={`${
                selectedTab === "/organization/templates"
                  ? "organizationSidebarTabSelected clickable"
                  : "organizationSidebarTab clickable"
              } ${!isOpen ? "collapsedBarClass" : ""}`}
              data-title={!isOpen ? "Templates" : ""}
            >
              <img height={26} width={26} src={GetImages.templatesOrgIcon} />
              <p>Templates</p>
            </div>
          </PermissionGuard>
        </>
      ) : (
        <>
          <PermissionGuard permission="Subscription">
            <div
              onClick={() => {
                navigate("mysubscription");
              }}
              className={`${
                selectedTab === "/platform-settings/mysubscription"
                  ? "organizationSidebarTabSelected clickable"
                  : "organizationSidebarTab clickable"
              } ${!isOpen ? "collapsedBarClass" : ""}`}
              data-title={!isOpen ? "My Subscription" : ""}
            >
              <img
                height={26}
                width={26}
                src={GetImages.subscriptionSidebarIcon}
              />
              <p>My Subscription</p>
            </div>
          </PermissionGuard>

          <PermissionGuard permission="MyProfile">
            <div
              onClick={() => {
                navigate("myprofile");
              }}
              className={`${
                selectedTab === "/platform-settings/myprofile"
                  ? "organizationSidebarTabSelected clickable"
                  : "organizationSidebarTab clickable"
              } ${!isOpen ? "collapsedBarClass" : ""}`}
              data-title={!isOpen ? "My Profile" : ""}
            >
              <img
                height={26}
                width={26}
                src={GetImages.myProfileSidebarIcon}
              />
              <p>My Profile</p>
            </div>
          </PermissionGuard>

          <PermissionGuard permission="Feedback">
            <div
              onClick={() => {
                navigate("Feedback");
              }}
              className={`${
                selectedTab === "/platform-settings/Feedback"
                  ? "organizationSidebarTabSelected clickable"
                  : "organizationSidebarTab clickable"
              } ${!isOpen ? "collapsedBarClass" : ""}`}
              data-title={!isOpen ? "Feedback" : ""}
            >
              <img height={26} width={26} src={GetImages.feedbackSidebarIcon} />
              <p>Feedback</p>
            </div>
          </PermissionGuard>

          <PermissionGuard permission="About">
            <div
              onClick={() => {
                navigate("about");
              }}
              className={`${
                selectedTab === "/platform-settings/about"
                  ? "organizationSidebarTabSelected clickable"
                  : "organizationSidebarTab clickable"
              } ${!isOpen ? "collapsedBarClass" : ""}`}
              data-title={!isOpen ? "About" : ""}
            >
              <img height={26} width={26} src={GetImages.aboutSidebarIcon} />
              <p>About</p>
            </div>
          </PermissionGuard>
        </>
      )}
    </div>
  );
};

export default OrganizationSidebar;
